import React from 'react';
import TickIcon from '../../../assets/images/companion/tick.svg';
import phrasesType from '../../proptypes/phrases';

const CompletedBrainGames = ({
  phrases: {
    companionSessions: {
      brainGames,
      gameComplete,
      allGamesCompleteBlurbWithCompleteProfile,
    },
  },
}) => (
  <>
    <div className="icon">
      <TickIcon />
    </div>
    <h2 className="h2 display-font text-center">{brainGames}</h2>
    <p className="text-center">
      {gameComplete}
    </p>
    <p className="text-center">
      {allGamesCompleteBlurbWithCompleteProfile}
    </p>
  </>
);

CompletedBrainGames.propTypes = {
  phrases: phrasesType.isRequired,
};

export default CompletedBrainGames;
